// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import GamesProvider from "./pages/context/GamesContext"; // keep your provider
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
<HelmetProvider>
    <GamesProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GamesProvider>
    </HelmetProvider>

);
